import { Reveal, Overline } from "./Reveal";
import { REVIEWS } from "./data";
import { Star, Quote } from "lucide-react";

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="py-24 md:py-40 bg-surface/40 border-y border-line/40">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
        <Reveal className="lg:col-span-7">
          <Overline>Why guests trust it</Overline>
          <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl mt-6">
            Our guests say it best
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="border border-line/60 rounded-xl p-8 flex items-center gap-6">
            <span className="font-serif text-6xl md:text-7xl text-primary leading-none">9.8</span>
            <div>
              <div className="flex gap-1 mb-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                ))}
              </div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-textMuted">
                Outstanding guest rating
              </p>
              <p className="font-sans text-sm text-textMuted mt-1">Consistently glowing reviews</p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <blockquote
              data-testid={`review-${i}`}
              className="h-full border border-line/60 rounded-xl p-8 flex flex-col justify-between hover:border-primary/40 transition-colors duration-400"
            >
              <Quote className="w-7 h-7 text-primary/50 mb-6" strokeWidth={1.2} />
              <p className="font-serif italic text-xl md:text-2xl text-textMain/90 leading-snug flex-1">
                "{r.quote}"
              </p>
              <footer className="mt-8 pt-6 border-t border-line/60">
                <p className="font-sans text-sm text-textMain">{r.author}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-textMuted mt-1">
                  {r.context}
                </p>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
